import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import styles from './forgotPassword.module.css';
import { Back } from '../../../Svg';
import { useDispatch, useSelector } from 'react-redux';
import { forgotPasswordThunk } from '../../redux/forgotPasswordSlice';

const ForgotPassword = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { loading, success, error } = useSelector((state) => state.forgotPassword);
    const [forgotTrigger, setForgotTrigger] = useState(false)

    // Formik form handling and validation


    const formik = useFormik({
        initialValues: {
            email: ''
        },
        validationSchema: Yup.object({
            email: Yup.string()
                .email('Invalid email address')
                .required('Email is required')
        }),
        onSubmit: async (values) => {
            setForgotTrigger(true)
            dispatch(forgotPasswordThunk(values.email));
        }
    });

    useEffect(() => {
        if (success && forgotTrigger) {
            const email = formik.values.email;
            navigate('/verifyEmail', { state: { email } });
            setForgotTrigger(false)
        }

    }, [success, forgotTrigger])

    return (
        <div className={styles.loginContainer}>
            <div className={styles.loginInner}>
                <div className={styles.loginCol1} onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
                    <img src='/assets/logo.png' alt="Logo" />
                </div>
                <div className={styles.loginCol2}>
                    <div className={styles.loginCard}>
                        <div
                            className={styles.backLogin}
                            onClick={() => navigate('/login')}
                            style={{ cursor: 'pointer' }}
                        >
                            <Back />
                            <span>Back to login</span>
                        </div>
                        <div className={styles.loginContent}>
                            <h3>Forgot Password</h3>
                            <form className={styles.loginForm} onSubmit={formik.handleSubmit}>
                                <div className={styles.loginInputGroup}>
                                    <label>Email Address</label>
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder="Enter email id"
                                        value={formik.values.email}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        required
                                    />
                                    {formik.touched.email && formik.errors.email ? (
                                        <div className={styles.error}>{formik.errors.email}</div>
                                    ) : null}
                                </div>
                                <button type="submit" className={styles.loginButton} disabled={loading}>
                                    {loading ? 'please wait...' : "Submit"}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
